/* eslint max-len: 0 */

import React from 'react';
import Helmet from 'react-helmet';
import Footer from '../components/Footer';
import Container from '../components/Container';
import Header from '../components/Header';
import config from '../../config/website';

const Print = () => (
  <React.Fragment>
    <Helmet title={`Print | ${config.siteTitle}`} />
    <Header slim title="PRINT" />
    <div style={{ marginTop: '3rem' }}>
      <Container>
        <h2>Content</h2>
        <p>
          Print Data <br />
          N/A <br />
          Unknown
        </p>
      </Container>
    </div>
    <Footer />
  </React.Fragment>
);

export default Print;



// WEBPACK FOOTER //
// ./src/pages/print.jsx